import { dashBoardConstants, nameSpace } from "../constants/dashboard.constant";

const initialState = {
  data: null,
};

export const getSpecificCampaignChart = (state = initialState, action) => {
  switch (action.type) {
    case dashBoardConstants[`DATA_${nameSpace}_REQUEST`]:
      return {
        ...state,
        data: action.data,
      };

    default:
      return state;
  }
};
